import { cn } from "@omni/utils/styles/tw.merge";
import { ChangeEventHandler, FocusEventHandler } from "react";

import { Input } from "@/components/Form/Base/input.component";
import { InputGroup } from "@/components/Form/Base/inputGroup.component";
import { InputGroupText } from "@/components/Form/Base/inputGroupText.component";

type Props = {
    quantityEditable: boolean;
    decreaseDisabled: boolean;
    increaseDisabled: boolean;
    value: number;
    disabled?: boolean;
    min?: number;
    max?: number;
    name?: string;
    valid?: boolean;
    invalid?: boolean;
    "aria-label"?: string;
    className?: string;
    onDecrease: () => void;
    onIncrease: () => void;
    onChange: ChangeEventHandler<HTMLInputElement>;
    onBlur: FocusEventHandler<HTMLInputElement>;
};

export const AmountFieldComponent = ({
    quantityEditable,
    decreaseDisabled,
    increaseDisabled,
    value,
    disabled,
    min,
    max,
    name,
    valid,
    invalid,
    "aria-label": ariaLabel,
    className,
    onDecrease,
    onIncrease,
    onChange,
    onBlur
}: Props) => {
    return (
        <InputGroup className={cn("tw:min-w-32! tw:max-w-32!", className)}>
            {quantityEditable && (
                <InputGroupText
                    onClick={onDecrease}
                    className={cn({
                        "tw:bg-tertiary": decreaseDisabled,
                        "tw:cursor-pointer tw:bg-background tw:hover:bg-grey":
                            !decreaseDisabled
                    })}
                >
                    <i className={cn("las la-minus")} />
                </InputGroupText>
            )}
            <Input
                className={cn("tw:rounded-none! tw:text-center tw:bg-none")}
                disabled={!quantityEditable || disabled}
                min={min}
                max={max}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                type={"number"}
                inputMode={"numeric"}
                pattern={"[0-9]*"}
                name={name}
                valid={valid}
                invalid={invalid}
                aria-label={ariaLabel}
            />
            {quantityEditable && (
                <InputGroupText
                    onClick={() => onIncrease()}
                    className={cn({
                        "tw:bg-grey-light ": increaseDisabled,
                        "tw:cursor-pointer tw:bg-background tw:hover:bg-grey":
                            !increaseDisabled
                    })}
                >
                    <i className={cn("las la-plus")} />
                </InputGroupText>
            )}
        </InputGroup>
    );
};
